import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-filter-budgets',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './mdl-filter-budgets.html',
  styleUrl: './mdl-filter-budgets.css' 
})
export class MdlFilterBudgets {
  constructor(
    public mdl: MatDialogRef<MdlFilterBudgets>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.filters = { ...this.filters, ...data };
    }
  }

  filters = {
    allSyncStatus: true,
    allDateRanges: true,
    priceRange: 'all',
    dateRange: 'all',
    syncStatus: {
      sincronizado: false,
      noSincronizado: false
    },
    dateRanges: {
      proximos7dias: false,
      proximos30dias: false,
      vencidos: false
    }
  };

  syncTypes: Array<keyof typeof this.filters.syncStatus> = [
    'sincronizado',
    'noSincronizado'
  ];

  dateRangeTypes: Array<keyof typeof this.filters.dateRanges> = [
    'proximos7dias',
    'proximos30dias',
    'vencidos'
  ];

  toggleAllSyncStatus() {
    if (this.filters.allSyncStatus) {
      for (const key of this.syncTypes) {
        this.filters.syncStatus[key] = true;
      }
    } else {
      for (const key of this.syncTypes) {
        this.filters.syncStatus[key] = false;
      }
    }
  }

  onSyncStatusChange() {
    const allSyncSelected = this.syncTypes.every(key => this.filters.syncStatus[key]);
    const anySyncSelected = this.syncTypes.some(key => this.filters.syncStatus[key]);
    
    this.filters.allSyncStatus = allSyncSelected;
    
    if (!anySyncSelected) {
      this.filters.allSyncStatus = true;
      this.toggleAllSyncStatus();
    }
  }

  toggleAllDateRanges() {
    if (this.filters.allDateRanges) {
      for (const key of this.dateRangeTypes) {
        this.filters.dateRanges[key] = true;
      }
    } else {
      for (const key of this.dateRangeTypes) {
        this.filters.dateRanges[key] = false;
      }
    }
  }

  onDateRangeChange() {
    const allDateRangesSelected = this.dateRangeTypes.every(key => this.filters.dateRanges[key]);
    const anyDateRangeSelected = this.dateRangeTypes.some(key => this.filters.dateRanges[key]);
    
    this.filters.allDateRanges = allDateRangesSelected;
    
    if (!anyDateRangeSelected) {
      this.filters.allDateRanges = true;
      this.toggleAllDateRanges();
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  applyFilters() {
    this.mdl.close(this.filters);
  }
}